module.exports = __webpack_public_path__ + "img/MAD.663ec67f.svg";